<template>
  <!-- 数字展厅 -->
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form" label-width="90px">
        <el-row type="flex" :gutter="20">
          <!-- <el-col :span="6">
            <el-form-item class="mb-20" label="订单号：">
              <el-input v-model="form.name" placeholder="请输入订单号"></el-input>
            </el-form-item>
          </el-col> -->

          <el-col :span="6">
            <el-form-item label="预约日期：" prop="appointDates">
              <el-date-picker v-model="appointDates" type="daterange" @change="handleAppointDates"
                value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="手机号：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="6">
            <el-form-item label="证件类型：">
              <el-select v-model="form.type" placeholder="请选择证件类型">
                <el-option v-for="item in cardList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->

          <el-col :span="6">
            <el-form-item label="证件号码：" prop="identificationNumber">
              <el-input v-model="form.identificationNumber" placeholder="请输入证件号码 "></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="渠道：" prop="platform">
              <el-select v-model="form.platform" placeholder="请选择支付平台">
                <el-option v-for="item in platformList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="18">
            <div class="tr">
              <el-button type="primary" @click="getTableList">查询</el-button>
              <el-button @click="resetForm('form')">重置</el-button>
            </div>
          </el-col>

        </el-row>
      </el-form>

      <!-- <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </div> -->
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">

      <div class="button">
        <el-row type="flex">
          <el-popover placement="bottom" width="150" trigger="click">
            <el-checkbox-group @change="handleCheck" v-model="checkList">
              <el-checkbox :label="item.propName" v-for="(item, i) in checkLabels" :key="i" style="display: block;">{{
                item.label }}</el-checkbox>
            </el-checkbox-group>
            <span class="icon-wrapper" slot="reference">
              <svg-icon icon-class="shaixuan" class-name="icon-menu" />
            </span>
          </el-popover>

          <el-popover class="pop-wrapper" placement="bottom" width="150" trigger="click">
            <span class="icon-wrapper" slot="reference">
              <svg-icon icon-class="export" class-name="icon-menu" />
            </span>
          </el-popover>

          <span class="icon-wrapper">
            <svg-icon icon-class="print" class-name="icon-menu" />
          </span>

        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" :row-key="(row) => { return row.id }" stripe
          :data="tableData">
          <el-table-column type="selection" :reserve-selection="true" width="42"></el-table-column>
          <template v-for="item in checkLabels">
            <el-table-column v-if="item.show" :prop="item.propName" :label="item.label" :key="item.label"
              show-overflow-tooltip>
            </el-table-column>
          </template>
          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">核销</a>

            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>


  </div>
</template>

<script>

export default {
  data() {
    return {
      form: {
        name: '',
        phone: '',
        platform: '',
        appointDates: '',
        identificationNumber: ''
      },
      appointDates: null,
      platformList: [{ value: '1', label: '支付宝' }, { value: '2', label: '微信' }],
      cardList: [{ value: '1', label: '身份证' }, { value: '2', label: '护照' }, { value: '3', label: '港澳台通行证' }, { value: '4', label: '外国人永居证' }],
      statusList: [{ value: '0', label: '手动取消' }, { value: '1', label: '待参观' }, { value: '2', label: '已入馆' }, { value: '3', label: '已过期' }],
      checkLabels: [{ label: '订单号', show: true, propName: 'orderNo' }, { label: '日期', show: true, propName: 'appointEntryTime' }, { label: '开始时间', show: true, propName: 'startTime' }, { label: '结束时间', show: true, propName: 'endTime' }, { label: '姓名', show: true, propName: 'name' }, { label: '手机号', show: true, propName: 'phone' }, { label: '证件号码', show: true, propName: 'identificationNumber' }, { label: '订单状态', show: true, propName: 'orderStatusName' }, { label: '入馆/取消时间', show: true, propName: 'entryTime' }],
      checkList: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      chooseRowIds: '',
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.appointSetting.getAppointOrderList({
        ...this.form,
        id: this.$route.query.id,
        orgId: this.$route.query.orgId,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          this.tableData = res.result
          this.total = res.page.allRow
        } else {
          this.$message.error(res.message)
        }
      })
    },

    handleAppointDates(arr) {
      if (arr && arr.length) {
        this.form.appointDates = arr[0] + ' - ' + arr[1]
      } else {
        this.form.appointDates = ''
      }
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.id)
      })
      this.chooseRowIds = arr.join(',')
    },

    setHead() {
      this.checkLabels.map(item => {
        this.checkList.push(item.propName)
      })
    },

    // 动态修改表头
    handleCheck(key) {
      for (let i = 0; i < this.checkLabels.length; i++) {
        if (this.checkList.includes(this.checkLabels[i].propName)) {
          this.checkLabels[i].show = true;
        } else {
          this.checkLabels[i].show = false;

        }
      }
      console.log(this.checkList)
    },


    // 重置查询
    resetForm() {
      this.$refs['form'].resetFields()
      this.appointDates = null
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    handleEdit(obj) {
      this.$common
        .confirm1('确认要操作该数据?')
        .then(function () {
          // return delCollection(obj.id)
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success('删除成功')
            this.getData()
          } else {
            this.$message.error(res.msg || '系统异常')
          }
        })
        .catch(() => { })
    },

    // 删除
    handleDelete(obj) {
      this.$common
        .confirm1('是否确认删除?')
        .then(function () {
          // return delCollection(obj.id)
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success('删除成功')
            this.getData()
          } else {
            this.$message.error(res.msg || '系统异常')
          }
        })
        .catch(() => { })

      return
      this.$common.confirm(
        {
          content: `是否确认删除？`,
          title: '系统提示',
        }, () => {
          this.$api.applet.delDigitalExhibition({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },
  },
  created() {
    this.setHead()
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  .com-list-header {
    padding-right: 30px;

    .el-row--flex {
      flex-wrap: wrap;
    }
  }

  .com-list-content {
    .el-row--flex {
      justify-content: end;
    }
  }

  .icon-wrapper {
    display: flex;
    width: fit-content;
    padding: 6px;
    margin-left: 20px;
    border: 1px solid #ccc;
    justify-content: center;
    align-items: center;

    &:hover {
      cursor: pointer;
      border: 1px solid #999;
      transition: .5s all;

    }

    .icon-menu {
      font-size: 20px;
    }
  }

  /deep/ .el-form-item {
    margin-bottom: 20px;

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;

      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .avatar {
          width: 100%;
          height: 120px;
          object-fit: contain;
        }

        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }

      .tip-img {
        left: 0;
      }
    }
  }
}
</style>